import React from 'react'
import { browserHistory } from 'react-router'
import Button from '../Button'
import classes from './Modal.scss'
import 'whatwg-fetch'

class ViewRequestModal extends React.Component {

  constructor (props) {
    super(props)

    const self: any = this
    self.state = { sending: false }
    self.closeModal = self.closeModal.bind(self)
    self.acceptRequest = self.acceptRequest.bind(self)
    self.denyRequest = self.denyRequest.bind(self)
  }

  closeModal () {
    const { closeViewRequestModal } = this.props
    browserHistory.push('/friends')
    closeViewRequestModal()
  }

  acceptRequest () {
    const { baseUrl, request } = this.props
    const { id } = request
    const { sending } = this.state
    if (sending) { return }

    this.setState({ sending: true })
    fetch(`${baseUrl}/friends/accept`, {
      method: 'POST',
      body: JSON.stringify({ id }),
      credentials: 'include',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }).then(res => res.json())
      .then(res => {
        this.setState({ sending: false })
        if (res.result === 'ok') {
          this.closeModal()
          window.location.href = '/friends'
        } else {
          alert(res.err || res.message)
        }
      })
  }

  denyRequest () {
    const { baseUrl, request } = this.props
    const { id } = request
    const { sending } = this.state
    if (sending) { return }

    this.setState({ sending: true })
    fetch(`${baseUrl}/friends/deny`, {
      method: 'POST',
      body: JSON.stringify({ id }),
      credentials: 'include',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }).then(res => res.json())
      .then(res => {
        this.setState({ sending: false })
        if (res.result === 'ok') {
          this.closeModal()
          window.location.href = '/friends'
        } else {
          alert(res.err || res.message)
        }
      })
  }

  render () {
    const { request } = this.props
    const { sending } = this.state
    const btnClasses = [classes.modalBtn, sending && classes.disabled].join(' ')
    const btnText = sending ? 'Accepting...' : 'Accept Request'

    return (
      <div>
        <div className={classes.overlay}></div>
        <div className={classes.modal}>
          <h1 className={classes.modalText}>Friend Request</h1>
          <h2>From: {request.name}</h2>
          <div style={{width: '70%', margin: '0 auto'}}>
            <Button className={btnClasses} value={btnText} onClick={this.acceptRequest} />
            <span className={classes.denyText} onClick={this.denyRequest}>Deny Request</span>
          </div>
          <span onClick={this.closeModal} className={classes.closeModal}><i className={['fa', 'fa-times-circle'].join(' ')}></i></span>
        </div>
      </div>
    )
  }
}

export default ViewRequestModal



/** WEBPACK FOOTER **
 ** ./src/components/Modals/ViewRequestModal.js
 **/